"use client";
import axiosInstance from "@/service/axiosInstance";
import { Field, Formik } from "formik";
import { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import Select from "react-select";

const UserDetails = ({
  userDetailsModal,
  setUserDetailsModal,
  phoneNumber,
}: any) => {
  const [userType, setUserType] = useState("");
  const [entityType, setEntityType] = useState("");
  const [userData, setUserData] = useState<any>(null);
  const userTypeOptions = [
    { value: "Parent", label: "Parent" },
    { value: "Student", label: "Student" },
    { value: "Faculty", label: "Faculty" },
    { value: "VT", label: "VT" },
    { value: "VC", label: "VC" },
    { value: "ResourcePerson", label: "Resource Person" },
    { value: "Others", label: "Others" },
  ];

  const entityTypeOptions = [
    { value: "IndusEdutrain", label: "Indus Edutrain" },
    { value: "SkillTree", label: "Skill Tree" },
    { value: "Others", label: "Others" },
  ];

  const getLabel = (type: any) => {
    switch (type) {
      case "Parent":
        return "Parent";
      case "Student":
        return "Student";
      case "Faculty":
        return "Faculty";
      case "VT":
        return "VT";
      case "VC":
        return "VC";
      case "ResourcePerson":
        return "Resource Person";
      default:
        return "User";
    }
  };
  const labelPrefix = getLabel(userType);

  useEffect(() => {
    const fetchUserData = async () => {
      if (userDetailsModal) {
        console.log("userDetailsModal", userDetailsModal);
        try {
          const public_token = process.env.NEXT_PUBLIC_API_TOKEN;
          const response = await axiosInstance.get(`/user/${phoneNumber}`, {
            headers: {
              "x-api-token": `Bearer ${public_token}`,
            },
          });
          // Do something with the response
          console.log("User data:", response.data);
          setUserData(response.data);
          setUserType(response.data.userType || "");
          setEntityType(response.data.entityType || "");
        } catch (error) {
          console.error("Error fetching user data:", error);
        }
      }
    };
    fetchUserData();
  }, [userDetailsModal]);

  return (
    <>
      {userDetailsModal && (
        <Modal show={userDetailsModal} centered backdrop="static">
          <Modal.Header>
            <Modal.Title>User Details</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Formik
              initialValues={{
                userType: userData?.userType || "",
                entityType: userData?.entityType || "",
                firstName: userData?.Firstname || "",
                lastName: userData?.Lastname || "",
                schoolName: userData?.schoolName || "",
                email: userData?.EmailPreferred || "",
                addressLine1: userData?.addressLine1 || "",
                addressLine2: userData?.addressLine2 || "",
                city: userData?.City_StAdd || "",
                state: userData?.State_StAdd || "",
                zipCode: userData?.Pincode_StAdd || "",
              }}
              enableReinitialize
              onSubmit={() => {}}
            >
              {({ values }) => (
                <form>
                  {/* User Type */}
                  <div className="mb-10">
                    <label>Title</label>
                    <Select
                      value={userTypeOptions.find(
                        (option) => option.value === values.userType,
                      )}
                      isDisabled
                      classNamePrefix="react-select"
                    />
                  </div>

                  {/* Entity Type */}
                  {["VT", "VC", "ResourcePerson"].includes(values.userType) && (
                    <div className="mb-10">
                      <label>Entity</label>
                      <Select
                        value={entityTypeOptions.find(
                          (option) => option.value === values.entityType,
                        )}
                        isDisabled
                        classNamePrefix="react-select"
                      />
                    </div>
                  )}

                  {/* First & Last Name */}
                  <div className="mb-10 d-flex gap-3">
                    <div className="form-group">
                      <label>First Name</label>
                      <Field
                        name="firstName"
                        readOnly
                        className="form-control"
                      />
                    </div>
                    <div className="form-group">
                      <label>Last Name</label>
                      <Field
                        name="lastName"
                        readOnly
                        className="form-control"
                      />
                    </div>
                  </div>

                  {/* School & Email */}
                  <div className="mb-10 d-flex gap-3">
                    <div className="form-group">
                      <label>School Name</label>
                      <Field
                        name="schoolName"
                        readOnly
                        className="form-control"
                      />
                    </div>
                    <div className="form-group">
                      <label>Email</label>
                      <Field name="email" readOnly className="form-control" />
                    </div>
                  </div>

                  {/* Address */}
                  <div className="form-group mb-10">
                    <label>Address Line 1</label>
                    <Field
                      name="addressLine1"
                      readOnly
                      className="form-control"
                    />
                  </div>

                  <div className="form-group mb-10">
                    <label>Address Line 2</label>
                    <Field
                      name="addressLine2"
                      readOnly
                      className="form-control"
                    />
                  </div>

                  {/* Zip Code */}
                  <div className="form-group mb-10">
                    <label>Postal/Zip Code</label>
                    <Field name="zipCode" readOnly className="form-control" />
                  </div>

                  {/* City & State */}
                  <div className="mb-10 d-flex gap-3">
                    <div className="form-group">
                      <label>City</label>
                      <Field name="city" readOnly className="form-control" />
                    </div>
                    <div className="form-group">
                      <label>State</label>
                      <Field name="state" readOnly className="form-control" />
                    </div>
                  </div>
                </form>
              )}
            </Formik>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => setUserDetailsModal(false)}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      )}
    </>
  );
};

export default UserDetails;
